import React, { Component } from 'react';

class EstheticianPicksConten extends Component {

   

    constructor(props) {
        super(props);

        this.handleOpenText = this.handleOpenText.bind(this);

        this.state = {
            isShowText:false,
            contenText:this.props.product.estheticianPickNote
        };
       
    }

    componentDidMount() {
    }

    handleOpenText(){
        this.setState({
            isShowText: !this.state.isShowText
        });
    }


    render() {
            return (
                <div className="paragraphSemiBold2 product-first-title" style={this.state.isShowText ?{bottom: '90%'}:{top: '-22px'}}>
                    <div className="esthetician-picks-title">
                        {
                            this.state.contenText ? <img className="dialogue-img" src="./images/explain/icont/dialogue.png"></img> : null
                        }
                        <span>Your esthetician’s pick</span>
                        {
                            this.state.contenText ? <i onClick={this.handleOpenText} className={this.state.isShowText ? "fa fa-angle-up fa-fw fa-arrea" : "fa fa-angle-down fa-fw fa-arrea"} ></i>:<i onClick={this.handleOpenText} style={{ visibility: 'hidden'}} className={"fa fa-angle-down fa-fw fa-arrea"} ></i>
                        }
                    </div>
                    {
                        this.state.contenText ? <div style={this.state.isShowText ?{display:'block'}:{display:'none'}} className="esthetician-picks-textConten paragraphRegular4">{this.state.contenText} </div>:null 
                    }
                </div>
            );
    }
}


export default EstheticianPicksConten;



// WEBPACK FOOTER //
// ./src/views/recommendations/EstheticianPicksConten.js